//----------------------------------------------------------------------------
// BFA10104G 共架申込 通信設備 - 地図/径間電柱ヘルパー
//----------------------------------------------------------------------------
import Point from '@arcgis/core/geometry/Point';
import PoleItem from '@/utils/pole-item';

/**
 * 電柱(1) 電柱情報作成
 */
export function k1pole(kkn) {
  return new PoleItem({
    areaCode:  kkn.k1areaCode,     // 地区コード
    areaName:  kkn.k1areaName,     // 地区名
    lineCode:  kkn.k1lineCode,     // 線路コード
    lineName:  kkn.k1lineName,     // 線路名
    poleNo:    kkn.k1poleNo,       // 電柱番号
    poleKind:  kkn.k1poleKind,     // 電柱区分
    latitude:  kkn.k1latitude,     // 緯度
    longitude: kkn.k1longitude,    // 経度
  });
}

/**
 * 電柱(2) 電柱情報作成
 */
export function k2pole(kkn) {
  return new PoleItem({
    areaCode:  kkn.k2areaCode,     // 地区コード
    areaName:  kkn.k2areaName,     // 地区名
    lineCode:  kkn.k2lineCode,     // 線路コード
    lineName:  kkn.k2lineName,     // 線路名
    poleNo:    kkn.k2poleNo,       // 電柱番号
    poleKind:  kkn.k2poleKind,     // 電柱区分
    latitude:  kkn.k2latitude,     // 緯度
    longitude: kkn.k2longitude,    // 経度
  });
}
